import React, { useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import TestiCardWeb, { TestiCardMobile } from "./TestiCard";

const Testimonials = ({ reviews }) => {
  const [index, setIndex] = useState(0);

  const visibleReviews = 3; // Number of testimonials to display at a time

  function leftShiftHandler() {
    setIndex((prev) =>
      prev === 0 ? reviews.length - visibleReviews : prev - 1
    );
  }

  function rightShiftHandler() {
    setIndex((prev) =>
      prev + visibleReviews >= reviews.length ? 0 : prev + 1
    );
  }

  // Mobile Size Design
  let reviews1 = reviews;

  function leftShiftHandler() {
    if (index - 1 < 0) {
      setIndex(reviews1.length - 1);
    } else {
      setIndex(index - 1);
    }
  }

  function rightShiftHandler() {
    if (index + 1 >= reviews1.length) {
      setIndex(0);
    } else {
      setIndex(index + 1);
    }
  }

  return (
    <>
      <div className="d-none d-md-block w-full max-w-6xl mx-auto relative mt-10">
        {/* Testimonials List */}
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 transition-all duration-500">
          {reviews.slice(index, index + visibleReviews).map((review, i) => (
            <TestiCardWeb key={i} review={review} />
          ))}
        </div>
      </div>

      <div
        className="d-block d-md-none w-[90vw] relative md:w-[700px] bg-white border border-x-blue-100 flex flex-col justify-center items-center mt-10 p-10 transition-all duration-700 hover:shadow-xl rounded-md mx-auto"
      >
        <TestiCardMobile review={reviews[index]}></TestiCardMobile>

        <div className="flex text-3xl mt-10 gap-3 text-violet-400 font-bold mx-auto">
          <button
            onClick={leftShiftHandler}
            className="cursor-pointer hover:text-violet-500 bg-pink-700 text-white px-2 rounded-full py-2 "
          >
            <FiChevronLeft />
          </button>
          <button
            onClick={rightShiftHandler}
            className="cursor-pointer hover:text-violet-500 bg-pink-700 text-white px-2 rounded-full py-2"
          >
            <FiChevronRight />
          </button>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
